import { render, staticRenderFns } from "./succession-file-documents.vue?vue&type=template&id=a1ca5cb8&"
import script from "./succession-file-documents.vue?vue&type=script&lang=js&"
export * from "./succession-file-documents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports